import React from "react";
import { PAYMENT_LABEL, PAYMENT_SUBTEXT } from "@/lib/constants";
import { Route, Clock, Banknote, Loader2 } from "lucide-react";

export const PriceCard = ({ quote, loading }) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center gap-2 rounded-2xl border border-[#1F293D] bg-[#151b2b] p-6 text-slate-400">
        <Loader2 className="h-4 w-4 animate-spin" />
        <span className="text-sm">Calcul de la distance réelle…</span>
      </div>
    );
  }
  if (!quote) return null;

  return (
    <div data-testid="price-card" className="fade-up overflow-hidden rounded-2xl border border-[#ff6a00]/30 bg-[#151b2b]">
      <div className="grid grid-cols-2 divide-x divide-[#1F293D] border-b border-[#1F293D]">
        <div className="flex items-center gap-2 p-4">
          <Route className="h-4 w-4 text-[#ff6a00]" />
          <div>
            <div className="text-[10px] uppercase tracking-wide text-slate-500">Distance</div>
            <div className="font-mono text-lg font-bold text-white">{quote.distance_km} km</div>
          </div>
        </div>
        <div className="flex items-center gap-2 p-4">
          <Clock className="h-4 w-4 text-[#ff6a00]" />
          <div>
            <div className="text-[10px] uppercase tracking-wide text-slate-500">Durée est.</div>
            <div className="font-mono text-lg font-bold text-white">{quote.duration_min} min</div>
          </div>
        </div>
      </div>

      <div className="space-y-1.5 p-4 text-sm">
        <div className="flex justify-between text-slate-400">
          <span>Base {quote.service}</span>
          <span className="font-mono">{quote.base}€</span>
        </div>
        <div className="flex justify-between text-slate-400">
          <span>Supplément distance</span>
          <span className="font-mono">{quote.distance_surcharge > 0 ? `+${quote.distance_surcharge}€` : "0€"}</span>
        </div>
        {quote.weight_surcharge > 0 && (
          <div className="flex justify-between text-slate-400">
            <span>Supplément poids ({quote.weight_kg} kg)</span>
            <span className="font-mono">+{quote.weight_surcharge}€</span>
          </div>
        )}
        <div className="mt-2 flex items-end justify-between border-t border-[#1F293D] pt-3">
          <span className="font-display text-base font-bold text-white">Total</span>
          <span data-testid="quote-price" className="font-mono text-3xl font-extrabold text-[#ff6a00]">
            {quote.price}€
          </span>
        </div>
      </div>

      <div className="flex items-start gap-3 border-t border-[#78350F] bg-[#2A1E0D] p-4">
        <Banknote className="mt-0.5 h-5 w-5 shrink-0 text-[#FBBF24]" />
        <div>
          <div className="text-sm font-bold text-[#FBBF24]">{PAYMENT_LABEL}</div>
          <div className="mt-0.5 text-xs text-amber-200/70">{PAYMENT_SUBTEXT}</div>
        </div>
      </div>
    </div>
  );
};
